import { OperationImportContextModel } from '../operation-import-context-model';

export class MicrosoftOfficeOperationUnProtectionContextModel extends OperationImportContextModel {
}
